import features from './features';

const root = {
	features
};

export default root;
